import { MenuAim, Options } from "es6-menu-aim";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("SubmenuAim")
export class SubmenuAim implements AxInit {
    private menuAim: MenuAim;

    AxInit(init: any): void {
        let menu_root = document.getElementById('ax-navbar_sub');
    }
}

export enum MenuDirection {
    left = "left",
    right = "right",
    below = "below",
    above = "above",
}